module.exports = __webpack_public_path__ + "media/images/star-off-8737ab19b715893a12b9e5b3741cf5b3.svg";